export type PlusType = "Plus" | "Minus";
export const PlusIcon = ({ type }: { type?: PlusType }) => {
  const transform = type === "Plus" ? "rotate-90" : "";
  return (
    <div className={`transition-transform ${transform}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
      >
        {type === "Minus" ? (
          <path d="M200-440v-80h560v80H200Z" />
        ) : (
          <path d="M440-200v-240H200v-80h240v-240h80v240h240v80H520v240h-80Z" />
        )}
      </svg>
    </div>
  );
};
